import type { ActionFormResourceDetails } from 'react-components/dialog-forms/components/useNeedActionFormtypes';
import { defaultCboResourceFormValues } from './cboResourceForm.schema';
import { mapPlacePartialToResourceDetails } from './mapToResourceDetails.util';

/**
 * Empty need-action resource row for manual (non-Places) entry.
 *
 * @returns Partial row with {@link ActionFormResourceDetails.isCustomResource} set.
 */
export function createEmptyCustomResourceDetails(): Partial<ActionFormResourceDetails> {
  return {
    ...mapPlacePartialToResourceDetails({
      ...defaultCboResourceFormValues,
      isCustomResource: true,
      googlePlaceId: null,
    }),
    isCustomResource: true,
    googlePlaceId: null,
    cboRecordId: undefined,
  };
}
